module.exports = __webpack_public_path__ + "img/front.2614ad06.svg";